<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/PHuGpY/tc-custom/9781488014901.jpg?1705766092769" alt="This image is the cover for the book His Shy Cinderella"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">His Shy Cinderella
      </h1>
      <p class="bookDescription body article font2">
        <i>The real woman behind his rival</i><i> </i><br/><br/>Racing driver Brandon Stone is intent on proving he has what it takes to run his family business. First stop: procuring rival race car designers the McKenzies. But shy Angel McKenzie has no intention of selling up! <br/><br/>Angel has avoided the limelight most of her life. But with her family business under threat, she'll do anything it takes to save it. Working closely with Brandon ignites feelings she never knew existedhe may be the last person she should <i>ever</i> date, but her heart is telling her to break the rules!
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kate Hardy
      </h2>
      
      <p class="authorDescription body article">Kate Hardy has been a bookworm since she was a toddler. When she isn&#39;t writing Kate enjoys reading, theatre, live music, ballet and the gym. She lives with her husband, student children and their spaniel in Norwich, England. You can contact her via her website: www.katehardy.com</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6f04e6ac